<!-- src/components/device/commands/AccelCard.vue -->
<!-- Sensibilité au choc — partagé admin/client : une seule présentation, une seule liste de
     seuils. Ne déclenche que ce qui DÉCLENCHE ; le GPS, qui ne déclenche rien, a son propre
     encadré pour qu'on ne croie pas qu'éteindre l'un affaiblit l'autre. -->
<template>
  <div class="bg-white rounded-lg shadow p-4">
    <h3 class="font-semibold text-gray-800">
      {{ $t('choc.titre') }}
      <span v-if="technique" class="ml-1 text-xs font-normal text-gray-400">{{ $t('choc.technique') }}</span>
    </h3>
    <p class="mt-1 text-sm text-gray-500">
      {{ $t('choc.intro') }}
    </p>
    <div class="mt-3 flex flex-wrap items-center gap-2">
      <select v-model="valeur" class="form-control flex-1 min-w-[12rem]">
        <option value="off">{{ $t('choc.off') }}</option>
        <option value="very_high">{{ $t('choc.veryHigh') }}{{ technique ? ' (~94 mg)' : '' }}</option>
        <option value="high">{{ $t('choc.high') }}{{ technique ? ' (~250 mg)' : '' }}</option>
        <option value="medium">{{ $t('choc.medium') }}{{ technique ? ' (~500 mg)' : '' }}</option>
        <option value="low">{{ $t('choc.low') }}{{ technique ? ' (~1000 mg)' : '' }}</option>
      </select>
      <button @click="send('accel_config', { sensitivity: valeur })"
              class="btn btn-primary text-sm" :disabled="busy">
        {{ $t('choc.appliquer') }}
      </button>
    </div>
    <valeur-rapportee :rapporte="device.reported_config && device.reported_config.accel_sens"
                      :demande="device.accel_sensitivity" :libelle="nomSensibilite" />
  </div>
</template>

<script>
import { defineComponent, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import ValeurRapportee from './ValeurRapportee.vue';

export default defineComponent({
  name: 'AccelCard',
  components: { ValeurRapportee },
  props: {
    device:    { type: Object, required: true },
    send:      { type: Function, required: true },
    busy:      { type: Boolean, default: false },
    technique: { type: Boolean, default: false }
  },
  setup(props) {
    const { t } = useI18n();
    const valeur = ref('very_high');
    const CLES = { very_high: 'veryHigh', high: 'high', medium: 'medium', low: 'low', off: 'off' };
    const nomSensibilite = v => (CLES[v] ? t(`choc.${CLES[v]}`) : String(v));
    // Suit la valeur réellement réglée : chargement, push temps réel, config_report.
    watch(() => props.device.accel_sensitivity, v => { if (v) valeur.value = v; }, { immediate: true });
    return { valeur, nomSensibilite };
  }
});
</script>
